import { render, staticRenderFns } from "./OfferData.vue?vue&type=template&id=5597e0fc"
import script from "./OfferData.vue?vue&type=script&lang=ts"
export * from "./OfferData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports